/* RESPONSIBLE TEAM: team-omni */
import Model, { attr } from '@ember-data/model';
import { IntegrationState } from 'embercom/objects/standalone/constants';

export default class FinAgentApiSettings extends Model {
  @attr('boolean') declare isInstalled: boolean;
  @attr('string') declare accessToken: string | null;
  @attr('string') declare notificationMethod: string | null;
  @attr('string') declare webhookSecret: string | null;
  @attr('string') declare webhookUrl: string | null;

  get integrationState() {
    return this.isInstalled ? IntegrationState.Enabled : IntegrationState.NotConfigured;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'fin-agent-api/settings': FinAgentApiSettings;
  }
}
